import React from "react";
import {Card} from "react-bootstrap";
import style from "@/app/contact/contact.module.scss";
import ImageSuccess from "../../../public/success-email.webp";
import Image from "next/image";

const ContactSuccess = () => {
    return (
        <Card className={style.cardSuccess}>
            <Card.Body>
                <div className={style.titleSuccess}>Mesajul dumneavoastră a fost trimis cu succes.</div>
                <p className={style.messageSuccess}>
                    Vă mulțumim că ne-ați contactat și vă vom răspunde în cel mai scurt timp posibil!
                </p>
                <Image
                    style={{
                        width: "100%",
                        height: "auto",
                    }}
                    width={500}
                    height={500}
                    src={ImageSuccess}
                    alt="success-send"
                />
            </Card.Body>
        </Card>
    );
};

export default ContactSuccess;
